import React, { PureComponent } from "react";
import Icons from "customComponents/icons";
import CustomPolicyMessagePopover from "./CustomPolicyMessagePopover";
import "./CustomPolicyMessage.scss";

import { isEmpty } from "../../constants/is";
import Common from "../../constants/common";

export default class extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            openPopOver: false,
            anchorEl: ""
        };
    }

    handleRequestClose = () => {
        this.setState({ openPopOver: false });
    };

    onClickHandler = event => {
        event.stopPropagation();
        this.setState({ openPopOver: true, anchorEl: event.currentTarget });
    };

    policyWarningMsgFn(policyWarningMsg, policyJson, elem, temPolicyArr) {
        policyWarningMsg = [
            ...policyWarningMsg,
            ...Common.newRecursiveDrawPolicyWarningMsg(policyJson, temPolicyArr)
        ];
        return policyWarningMsg;
    }

    render() {
        const { openPopOver, anchorEl } = this.state;
        const { containerDisplayName, containerName, policy_json = {}, id } = this.props;

        if (isEmpty(policy_json)) return <div />;
        const cellKeys = Object.keys(policy_json);
        const hidePolicyViolation =
            containerName === "expense"
                ? policy_json[id] === undefined || isEmpty(policy_json[id])
                : cellKeys.some(key => isEmpty(policy_json[key]));

        if (hidePolicyViolation) return <div />;

        let policyWarningMsg = [];
        const temPolicyArr = [];
        if (id) {
            let arg = [policyWarningMsg, policy_json[id], temPolicyArr];
            if (id === "policy") {
                arg = [policyWarningMsg, policy_json, temPolicyArr];
            } else {
                arg = [policyWarningMsg, policy_json[id], temPolicyArr];
            }

            policyWarningMsg = this.policyWarningMsgFn(...arg);
        } else {
            cellKeys.forEach(elem => {
                const arg = [policyWarningMsg, policy_json[elem], temPolicyArr];
                policyWarningMsg = this.policyWarningMsgFn(...arg);
            });
        }
        let hardBlockIconCheck = policyWarningMsg.map(msgEle =>
            ["W", "w"].includes(msgEle.notification) ? true : false
        );

        let policyViolationIcon = (
            <div key={Common.uniqId()}>
                {hardBlockIconCheck.includes(false) ? (
                    <Icons
                        type={"hardblock"}
                        className={"hardblock-icon"}
                        active={openPopOver}
                        activeClass="hardblock-icon-active"
                        onClick={this.handleRequestCloseHandler}
                    />
                ) : (
                    <Icons
                        type="softblock"
                        interactive
                        className="policy-icon"
                        active={openPopOver}
                        activeClass="policy-icon-active"
                        onClick={this.handleRequestCloseHandler}
                    />
                )}
            </div>
        );

        return (
            <div
                className="policy-violation-container"
                onClick={this.onClickHandler}
                onKeyPress={this.onClickHandler}
                role="button"
                tabIndex="0"
            >
                {policyViolationIcon}

                <CustomPolicyMessagePopover
                    messages={policyWarningMsg}
                    containerDisplayName={containerDisplayName}
                    anchorEl={anchorEl}
                    open={openPopOver}
                    anchorOrigin={{ horizontal: "left", vertical: "top" }}
                    targetOrigin={{ horizontal: "right", vertical: "top" }}
                    onRequestClose={this.handleRequestClose}
                    handleRequestClose={this.handleRequestClose}
                />
            </div>
        );
    }
}
